/*
 * @Author: liyxt
 * @Date: 2020-06-01 14:08:06
 * @LastEditors: bbqin
 * @LastEditTime: 2023-02-02 10:59:46
 * @Description: file content
 */ 
import { opaqueEncrypt, opaqueDecrypt } from './cipher';
import { setSession, getSession, delSession } from './session';

const PUBKEY = new Set(['NCCAPPURL', 'browserTabs']);
// const cryptograph = new Cryptograph({ algorithmName: 'common' });
// const aeskey = cryptograph.getStaticSecretKey();
/**
 * @namespace Storage
*/

/**
 * 设置本地缓存<br/> store:缓存存储位置,'sessionStorage'或者'localStorage'默认为'localStorage'<br/> key:缓存key <br/> value: 缓存值 <br/> error: 设置缓存出现异常(存储失败)时的处理函数
 * @memberof Storage
 * @param {string} store=localStorage 缓存存储位置,'sessionStorage'或者'localStorage'默认为'localStorage'
 * @param {string} key 缓存key
 * @param {string} value 缓存值
 * @param {function} error 设置缓存出现异常(存储失败)时的处理函数
 */
export function setGlobalStorage (store, key, value, error) {
    if (!store) {
        return;
    }
    let insideTab = isInsideTab();
    if (!new Set(['NCCAPPURL', 'browserTabs']).has(key) && insideTab && store === 'sessionStorage') {
        setSession(key, value);
        return;
    }
    let storage = getStorage(store),
        storeCipher = localStorage.getItem('storeCipher') != '0';

    if (storeCipher) {
        value = opaqueEncrypt(String(value));
    }
    try {
        storage.setItem(key, value);
    } catch (e) {
        if(typeof error === "function"){
            error(e);
        }else{
            console.log(e);
        }
        
    }
    
}

/**
 * 获取本地缓存<br/> store:缓存存储位置,'sessionStorage'或者'localStorage'默认为'localStorage'<br/> key:缓存key 
 * @memberof Storage
 * @param {string} store=localStorage 缓存存储位置,'sessionStorage'或者'localStorage'默认为'localStorage'
 * @param {string} key 缓存key
 */
export function getGlobalStorage(store, key) {
    let insideTab = isInsideTab();
    if (!new Set(['NCCAPPURL', 'browserTabs']).has(key) && insideTab && store === 'sessionStorage') {
        return getSession(key);
    }
    let storage = getStorage(store);
    if (key && storage) {
        if (!store) {
            return;
        }
        let value = storage.getItem(key),
            storeCipher = localStorage.getItem('storeCipher') != '0';
        if (storeCipher && value !== null) {
            value = opaqueDecrypt(value);
        }
        return value;
    }
}

function isInsideTab() {
    let value = getStorage().getItem('INSIDE_TAB'),
        storeCipher = localStorage.getItem('storeCipher') != '0';
    if (storeCipher && value !== null) {
        value = opaqueDecrypt(value);
    }
    if (value) {
        value = JSON.parse(value);
    }
    return value;
}

/**
 * 删除本地缓存<br/> store:缓存存储位置,'sessionStorage'或者'localStorage'默认为'localStorage'<br/> key:缓存key 
 * @memberof Storage
 * @param {string} store=localStorage 缓存存储位置,'sessionStorage'或者'localStorage'默认为'localStorage'
 * @param {string} key 缓存key
 */
export function removeGlobalStorage (store, key) {
    if (!store) {
        return;
    }
    let insideTab = isInsideTab();
    if (!new Set(['NCCAPPURL', 'browserTabs']).has(key) && insideTab && store === 'sessionStorage') {
        delSession(key);
        return;
    }
    let storage = getStorage(store);
    if (key) {
        storage.removeItem(key);
    }
}

function getStorage(store) {
    let storage = localStorage;
    if (store === 'sessionStorage') {
        storage = sessionStorage;
    }
    return storage;
}

